import * as TYPE from '../types';
const initialState = [];
export const merchantListReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.MERCHANT_LIST_FOUND:
      return [...action.payload];
    default:
      return state;
  }
};
